import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';

import { Toolbar, TableList } from './components';
import api from 'services/api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const PlaningList = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [monitorings, setMonitoring] = useState([]);
  const [plannings, setPlannings] = useState([]);

  const fetchPlanningList = useCallback(async () => {
    try {
      const response = await api.get('plannings');

      setPlannings(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar]);

  const fetchMonitoringList = useCallback(async () => {
    try {
      const response = await api.get('monitorings');

      setMonitoring(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, setMonitoring]);

  useEffect(() => {
    fetchMonitoringList();
    fetchPlanningList();
  }, [fetchMonitoringList, fetchPlanningList]);

  return (
    <div className={classes.root}>
      <Toolbar monitorings={monitorings} fetchList={fetchPlanningList} />
      <div className={classes.content}>
        <TableList list={plannings} onFetch={fetchPlanningList} />
      </div>
    </div>
  );
};

export default PlaningList;
